import type { InventoryItem } from '@/modules/inventory/types';
import type { CommercialOperationType } from '@/modules/commercial/types';

const BLOCKED_STATUSES = new Set([
  'sold',
  'inactive',
  'maintenance',
  'repair',
  'inspection',
]);

export function isItemSelectableForCommercial(
  item: InventoryItem,
  operationType: CommercialOperationType,
): boolean {
  if (BLOCKED_STATUSES.has(item.status)) return false;
  if (operationType === 'sale') return item.mode === 'sale';
  if (operationType === 'rental' || operationType === 'quotation') {
    return item.mode === 'rental' || item.mode === 'sale';
  }
  return true;
}

export function itemIneligibilityReason(
  item: InventoryItem,
  operationType: CommercialOperationType,
): string | null {
  if (item.status === 'sold') return 'Artículo vendido.';
  if (item.status === 'inactive') return 'Artículo inactivo.';
  if (item.status === 'maintenance') return 'En mantenimiento.';
  if (item.status === 'repair') return 'En reparación.';
  if (item.status === 'inspection') return 'En inspección.';
  if (operationType === 'sale' && item.mode !== 'sale') {
    return 'Solo artículos en modo venta.';
  }
  return null;
}
